<template>
    <div class="w-full mx-auto relative flex flex-col" style="max-width: 1400px; min-height: calc(100vh - 80px);">
        <div class="p-3">
            <Gallery :images="imagesForGallery" :keep-aspect-ratio="true" passClasses="max-h-[500px]" />
        </div>
        <div class="flex flex-col md:flex-row pt-12 md:pt-24 pb-24">
            <div class="px-12 lg:px-24 text-left flex flex-col w-full md:w-[60%] gap-16 md:gap-24">
                <div>
                    <h1 class="font-written text-4xl">Frauenkreis</h1>
                    <p class="text-lg text-gray-500 mt-3">Die Frauen unter sich.</p>
                    <p class="mt-5 max-w-lg lg:max-w-xl">
                        In regelmäßigen Abständen treffen sich die Frauen der Gemeinde in den umliegenden Ortschaften um
                        gemeinsam Kaffee zu trinken, sich zu unterhalten und thematisch auszutauschen.
                        <br>
                        <br>
                        Schau doch auch vorbei, wir freuen uns auf dich!
                        <br>
                        <br>
                    <p>
                        <span class="font-bold">Wo und wann?</span>
                        <br>Mannstedt, 1. Dienstag im Monat
                        <br>Guthmannshausen, 3. Mittwoch im Monat
                        <br>Olbersleben, 2. Mittwoch im Monat
                    </p>
                    </p>
                </div>
            </div>
            <GridNav />
        </div>
    </div>
</template>

<script>
import GridNav from '@/components/gridNav.vue';
import Gallery from '@/components/gallery.vue';

export default {
    name: 'Frauenkreis',
    data() {
        return {
            imagesForGallery: [
                {
                    url: "/assets/themenwelt/frauenkreis/frauenkreis-1.webp",
                    alt: "Frauenkreis 1",
                },
                {
                    url: "/assets/themenwelt/frauenkreis/frauenkreis-2.webp",
                    alt: "Frauenkreis 2"
                }
            ]
        }
    },
    components: {
        GridNav,
        Gallery
    }
}
</script>